module.exports = __webpack_public_path__ + "img/closeIsiBtn.6edd58e1.svg";